module.exports = __webpack_public_path__ + "assets/fb.3f188e88.svg";